import { observer } from 'mobx-react-lite';
import { Layout, Button } from 'Components';
import { useStores } from 'Hooks/useStore';
import { DashboardTabKey } from 'Services/Api/Dashboard/Types';
import { MyResultsWidgets } from 'Pages/Dashboard/tabs/MyResults/MyResults.types';
import { OpenInNewTab } from 'Pages/Dashboard/components';
import styles from './Courses.module.scss';

function Courses() {
    const stores = useStores();
    const { systemsStore, authStore } = stores;
    const isSuperAdmin = authStore.isCurrentUserSuperAdmin;

    return (
        <Layout className={styles.root}>
            <h1 className={styles.header}>Quick Links</h1>
            <div className={styles.card}>
                <h3 className={styles.title}>My Courses</h3>
                <OpenInNewTab
                    tab={DashboardTabKey.MyResults}
                    widget={MyResultsWidgets.MyCourses}
                    tenantId={isSuperAdmin ? null : systemsStore.selectedTenant.value}
                    tooltipPlacement="top"
                    button={(handleButtonClick) => (
                        <Button
                            onClick={handleButtonClick}
                            shape="round"
                            type="primary"
                            className={`${styles.btn} cta-prominent`}>Go To My Courses</Button>
                    )}
                />
            </div>
        </Layout>
    );
}

export default observer(Courses);